export const LOAD_VIEWER_SETTINGS = 'LOAD_VIEWER_SETTINGS';
export const UPDATE_VIEWER_SETTING = 'UPDATE_VIEWER_SETTING';
